export default __webpack_public_path__ + "static/media/3_Letras.37c889c3.webp";